var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 756,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "rgb(9, 132, 227)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.02,
      strokeWidth: 21
    },
    transform: "translate(-25, -79.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.02,
      strokeWidth: 21
    },
    transform: "translate(-25, 676.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.063333333333333,
      strokeWidth: 21
    },
    transform: "translate(-25, -58.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.063333333333333,
      strokeWidth: 21
    },
    transform: "translate(-25, 697.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.10666666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, -37.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.10666666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, 718.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.063333333333333,
      strokeWidth: 21
    },
    transform: "translate(-25, -16.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.063333333333333,
      strokeWidth: 21
    },
    transform: "translate(-25, 739.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.046,
      strokeWidth: 21
    },
    transform: "translate(-25, 4.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.046,
      strokeWidth: 21
    },
    transform: "translate(-25, 760.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.14133333333333,
      strokeWidth: 21
    },
    transform: "translate(-25, 25.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.14133333333333,
      strokeWidth: 21
    },
    transform: "translate(-25, 781.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.046,
      strokeWidth: 21
    },
    transform: "translate(-25, 46.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.046,
      strokeWidth: 21
    },
    transform: "translate(-25, 802.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.072,
      strokeWidth: 21
    },
    transform: "translate(-25, 67.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.072,
      strokeWidth: 21
    },
    transform: "translate(-25, 823.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.098,
      strokeWidth: 21
    },
    transform: "translate(-25, 88.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.098,
      strokeWidth: 21
    },
    transform: "translate(-25, 844.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.072,
      strokeWidth: 21
    },
    transform: "translate(-25, 109.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.072,
      strokeWidth: 21
    },
    transform: "translate(-25, 865.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.14133333333333,
      strokeWidth: 21
    },
    transform: "translate(-25, 130.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.14133333333333,
      strokeWidth: 21
    },
    transform: "translate(-25, 886.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.037333333333333,
      strokeWidth: 21
    },
    transform: "translate(-25, 151.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.037333333333333,
      strokeWidth: 21
    },
    transform: "translate(-25, 907.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.10666666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, 172.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.10666666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, 928.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.072,
      strokeWidth: 21
    },
    transform: "translate(-25, 193.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.072,
      strokeWidth: 21
    },
    transform: "translate(-25, 949.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.13266666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, 214.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.13266666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, 970.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.13266666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, 235.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.13266666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, 991.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.046,
      strokeWidth: 21
    },
    transform: "translate(-25, 256.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.046,
      strokeWidth: 21
    },
    transform: "translate(-25, 1012.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.080666666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, 277.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.080666666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, 1033.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.098,
      strokeWidth: 21
    },
    transform: "translate(-25, 298.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.098,
      strokeWidth: 21
    },
    transform: "translate(-25, 1054.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.072,
      strokeWidth: 21
    },
    transform: "translate(-25, 319.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.072,
      strokeWidth: 21
    },
    transform: "translate(-25, 1075.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.054666666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, 340.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.054666666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, 1096.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.15,
      strokeWidth: 21
    },
    transform: "translate(-25, 361.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.15,
      strokeWidth: 21
    },
    transform: "translate(-25, 1117.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.063333333333333,
      strokeWidth: 21
    },
    transform: "translate(-25, 382.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.063333333333333,
      strokeWidth: 21
    },
    transform: "translate(-25, 1138.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.080666666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, 403.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.080666666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, 1159.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.037333333333333,
      strokeWidth: 21
    },
    transform: "translate(-25, 424.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.037333333333333,
      strokeWidth: 21
    },
    transform: "translate(-25, 1180.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.028666666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, 445.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.028666666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, 1201.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.13266666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, 466.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.13266666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, 1222.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.046,
      strokeWidth: 21
    },
    transform: "translate(-25, 487.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.046,
      strokeWidth: 21
    },
    transform: "translate(-25, 1243.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.054666666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, 508.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.054666666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, 1264.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.028666666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, 529.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.028666666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, 1285.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.02,
      strokeWidth: 21
    },
    transform: "translate(-25, 550.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.02,
      strokeWidth: 21
    },
    transform: "translate(-25, 1306.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.028666666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, 571.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.028666666666667,
      strokeWidth: 21
    },
    transform: "translate(-25, 1327.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.072,
      strokeWidth: 21
    },
    transform: "translate(-25, 592.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.072,
      strokeWidth: 21
    },
    transform: "translate(-25, 1348.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.089333333333333,
      strokeWidth: 21
    },
    transform: "translate(-25, 613.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.089333333333333,
      strokeWidth: 21
    },
    transform: "translate(-25, 1369.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.098,
      strokeWidth: 21
    },
    transform: "translate(-25, 634.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#222",
    style: {
      opacity: 0.098,
      strokeWidth: 21
    },
    transform: "translate(-25, 1390.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.14133333333333,
      strokeWidth: 21
    },
    transform: "translate(-25, 655.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 53 C 17.5 0, 33 0, 50 53 S 83 106, 100 53 S 133 0, 150, 53",
    fill: "none",
    stroke: "#ddd",
    style: {
      opacity: 0.14133333333333,
      strokeWidth: 21
    },
    transform: "translate(-25, 1411.5)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.0a2f49a05eb19b2a2bbbda6f16b8b012.svg";
export { ForwardRef as ReactComponent };